import {BaseModel} from "../base.model";

export interface BrandLevel extends BaseModel {
    levelName?: string;
    paymentType?: string;
}

export const defaultBrandLevel:  Readonly<BrandLevel> = {};